import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useAuth } from "@/context/AuthContext";

const Logout = () => {
  const { logoutUser } = useAuth();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = async () => {
    if (isLoading) return;

    try {
      setIsLoading(true);
      await logoutUser();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center">
      <Card className="p-2">
        <Button
          className="cursor-pointer"
          onClick={handleLogout}
          disabled={isLoading}
        >
          {isLoading ? "Cerrando sesión..." : "Cerrar Sesión"}
        </Button>
      </Card>
    </div>
  );
};

export default Logout;
